
;(function(){
  document.documentElement.classList.add('amie-static-rendered');
  function initSearch(root){
    var input=root.querySelector('[data-collection-search-input]');
    var clear=root.querySelector('[data-collection-search-clear]');
    var summary=root.querySelector('[data-collection-search-summary]');
    var empty=root.querySelector('[data-collection-search-empty]');
    var groups=Array.prototype.slice.call(root.querySelectorAll('[data-search-group]'));
    if(!input||!summary||!groups.length)return;
    var total=Array.prototype.slice.call(root.querySelectorAll('[data-search]')).length;
    function apply(){
      var q=(input.value||'').trim().toLowerCase();
      var visible=0;
      var visibleGroups=0;
      groups.forEach(function(group){
        var cards=Array.prototype.slice.call(group.querySelectorAll('[data-search]'));
        var groupVisible=0;
        cards.forEach(function(card){
          var hit=!q || (card.getAttribute('data-search')||'').indexOf(q)>-1 || card.textContent.toLowerCase().indexOf(q)>-1;
          card.hidden=!hit;
          if(hit){groupVisible++; visible++;}
        });
        group.hidden=groupVisible===0;
        var count=group.querySelector('[data-group-count]');
        if(count)count.textContent=groupVisible;
        if(groupVisible)visibleGroups++;
      });
      if(clear)clear.hidden=!q;
      if(empty)empty.hidden=visible!==0;
      summary.textContent=q ? ('Showing '+visible+' of '+total+' products across '+visibleGroups+' sections.') : ('Showing all '+total+' products across '+groups.length+' sections.');
    }
    input.addEventListener('input', apply);
    if(clear)clear.addEventListener('click', function(){ input.value=''; input.focus(); apply(); });
    apply();
  }
  document.querySelectorAll('[data-collection-search]').forEach(initSearch);
})();
